module.exports = __webpack_public_path__ + "avatar_2x.png";